// The user's plan, written by server code to users/{uid} after a verified
// purchase. The app only reads it. A port of plan.dart.

export interface Plan {
  isProPlan: boolean;
  /** When Pro ends unless renewed; null means it doesn't expire. */
  expiresAt: string | null;
  /** In the 7-day free trial. */
  isTrial: boolean;
}

export const FREE_PLAN: Plan = { isProPlan: false, expiresAt: null, isTrial: false };

export function planFromUserRecord(data: Record<string, unknown> | undefined | null): Plan {
  if (!data) return FREE_PLAN;
  const expires = typeof data.planExpiresAt === 'string' && !Number.isNaN(Date.parse(data.planExpiresAt)) ? data.planExpiresAt : null;
  return { isProPlan: data.plan === 'pro', expiresAt: expires, isTrial: data.planIsTrial === true };
}

/** Pro and not yet expired, so a lapsed plan locks even if the server is late. */
export function isProOn(plan: Plan, now: Date = new Date()): boolean {
  return plan.isProPlan && (plan.expiresAt === null || now.getTime() < Date.parse(plan.expiresAt));
}
